import React from 'react';
import PropTypes from 'prop-types';
import Select from '../Select';
import subscriptions from '../../../constants/subscriptions';


const SubscriptionDropdown = ({ value, onChange }) => (
  <Select
    value={value}
    onChange={onChange}
    options={subscriptions}
  />
);

SubscriptionDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default SubscriptionDropdown;


// WEBPACK FOOTER //
// src/components/shared/SubscriptionDropdown/index.jsx